import { BaseModulePublicApi, addAuthToHeader } from "../../base/BaseModulePublicApi";

export class PublicQuizzesApi extends BaseModulePublicApi {
  basePath = "quizzes";

  async listPublic(workspaceId?: number | string, locale?: string) {
    const params = {
      ...(workspaceId ? { workspace_id: workspaceId } : {}),
      ...(locale ? { locale } : {}),
    };
    // The API scopes the public collection by workspace_id.
    const endpoints = ["/quizzes/public"];
    let lastError: any;
    for (const endpoint of endpoints) {
      try {
        const response = await this.axiosInstance!.get(endpoint, {
          params,
          headers: addAuthToHeader({}, this.token),
        });
        const payload: any = response.data;
        return payload;
      } catch (error) {
        lastError = error;
      }
    }
    throw lastError ?? new Error("Unable to load public quizzes");
  }

  async getPublic(slug: string, locale?: string) {
    const response = await this.axiosInstance!.get(`/quizzes/public/${encodeURIComponent(slug)}`, {
      params: locale ? { locale } : undefined,
      headers: addAuthToHeader({}, this.token),
    });
    return response.data;
  }

  async submitPublic(slug: string, data: any, locale?: string) {
    const response = await this.axiosInstance!.post(`/quizzes/public/${encodeURIComponent(slug)}/submit`, data, {
      params: locale ? { locale } : undefined,
      headers: addAuthToHeader({}, this.token),
    });
    return response.data;
  }
}
